import { autoinject } from "aurelia-framework";
import { BaseRangeRuleEditor } from "./base-range-rule-editor";
import { TreeNode } from "../tree-node";
import { Api } from "../../../services/api";
import { MdToastService } from "aurelia-materialize-bridge";
import { I18N } from "aurelia-i18n";

@autoinject
export class BatteryRuleEditor extends BaseRangeRuleEditor {

	constructor(api: Api, toastService: MdToastService, i18n: I18N) {
		super(api, toastService, i18n);
	}

	activate(model: any) {
		super.activate(model);
	}

	async applyChanges() {
		const data = `${this.requiredMinimum},${this.requiredMaximum}`;
		const result = await this.addOrUpdateProperty(data);
	}

	async delete() {
		const result = await super.deleteProperty(this.property);
	}
}
